import { graphql } from "@/config/graphql";
import { logrocket } from "@/config/logrocket";
import { ApolloError, useApolloClient, useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { create } from "zustand";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

const authQuery = graphql(`
  query authQuery {
    currentUser {
      id
      name
      email
      plants {
        plant {
          id
          name
        }
        permission
      }
    }
  }
`);

interface AuthState {
  invalidUser: boolean;
  setInvalidUser: (invalidUser: boolean) => void;
  clearInvalidUser: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  invalidUser: false,
  setInvalidUser: (invalidUser: boolean) => set({ invalidUser }),
  clearInvalidUser: () => set({ invalidUser: false }),
}));
export const useAuthLoading = () => {
  const { inProgress } = useMsal();
  const loading = inProgress !== "none";
  const { loading: queryLoading } = useQuery(authQuery, {
    fetchPolicy: "cache-only",
    skip: loading,
  });

  return loading || queryLoading;
};

export const useAuthLoader = () => {
  const client = useApolloClient();
  const isAuthenticated = useIsAuthenticated();
  const setInvalidUser = useAuth((store) => store.setInvalidUser);
  useEffect(() => {
    async function loadAuth() {
      console.log({
        msg: "loadAuth",
        isAuthenticated,
        tkn: localStorage.getItem("tkn"),
      });
      if (isAuthenticated || localStorage.getItem("tkn")) {
        try {
          const {
            data: { currentUser },
          } = await client.query({
            query: authQuery,
            fetchPolicy: "network-only",
          });
          if (!currentUser) {
            setInvalidUser(true);
            return;
          }
          logrocket?.identify(String(currentUser.id), {
            id: currentUser.id,
            name: currentUser.name,
            email: currentUser.email,
          });
        } catch (e) {
          console.error(e);
          if (e instanceof ApolloError) {
            if (
              e.graphQLErrors.some(
                (error) => error.extensions.code === "UNAUTHENTICATED"
              )
            ) {
              setInvalidUser(true);
              return;
            }
          }
        }
      }
    }
    loadAuth();
  }, [client, setInvalidUser, isAuthenticated]);
};

export const useForceUnauth = () => {
  const { inProgress } = useMsal();
  const loading = inProgress !== "none";
  const {
    data,
    loading: queryLoading,
    called,
  } = useQuery(authQuery, {
    fetchPolicy: "cache-only",
    skip: loading,
  });
  const navigate = useNavigate();
  useEffect(() => {
    console.log({ msg: "useForceUnauth", loading, queryLoading, called, data });
    if (loading) return;
    if (queryLoading || !called) return;
    if (data?.currentUser) navigate("/");
  }, [data, navigate, loading, queryLoading, called, inProgress]);
};
export const useForceAuth = () => {
  const { inProgress } = useMsal();
  const loading = inProgress !== "none";
  const {
    data,
    loading: queryLoading,
    called,
  } = useQuery(authQuery, {
    fetchPolicy: "cache-only",
    skip: loading,
  });
  const navigate = useNavigate();
  useEffect(() => {
    console.log({ msg: "useForceAuth", loading, queryLoading, called, data });
    if (loading) return;
    if (queryLoading || !called) return;
    if (!data?.currentUser) navigate("/ingresar");
  }, [data, navigate, loading, queryLoading, called, inProgress]);
};
